import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { getProvidedApp } from '~/base/utils/provided-getter'
import { ISignin, LocalizationData, LocalizationPath, UserType } from '@tokyojob/core'
import CLoginForm from '../common/c-login-form.component.vue'
import CSocialLogin from '../common/c-social-login.component.vue'
import { LocalizationService } from '@tokyojob/frontend-core'
import { getLocalization, RouterLinkFactory } from '@tokyojob/frontend-components'
import { IApp } from '~/types/nuxt'

// Declare props and emits

export default /*#__PURE__*/_defineComponent({
  __name: 'candidate-login-form.component',
  emits: ['submit'],
  setup(__props, { emit }) {


const App: IApp = getProvidedApp()
const localization: LocalizationData = getLocalization(App)
const signInTxt = LocalizationService.t<string>(localization, LocalizationPath.LoginPageSignIn)
const loginWithEmail = LocalizationService.t<string>(localization, LocalizationPath.LoginPageLoginWithEmail)
const signUpLinkText = LocalizationService.t<string>(localization, LocalizationPath.LoginPageSignUpLinkText)
const googleLoginText = LocalizationService.t<string>(localization, LocalizationPath.LoginPageGoogleLoginBtnText)
const facebookLoginText = LocalizationService.t<string>(localization, LocalizationPath.LoginPageFacebookLoginBtnText)
// Local state
const userType = ref(UserType.Candidate)
const signupLink = RouterLinkFactory.localizedLink('/auth/signup', App.localizationSelector.language)
const agentLoginLink = RouterLinkFactory.localizedLink('/auth/agent/login', App.localizationSelector.language)

// Methods
const submit = (seed: ISignin) => {
  emit('submit', seed)
}

return { __sfc: true,emit, App, localization, signInTxt, loginWithEmail, signUpLinkText, googleLoginText, facebookLoginText, userType, signupLink, agentLoginLink, submit, CLoginForm, CSocialLogin }
}

})